import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { keyframes } from 'styled-components';
export var slideDownKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n        opacity: 0;\n        transform: translateY(-150%);\n    }\n\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"])));